import styled, { keyframes } from 'styled-components'

const changeColor = keyframes`
  from {
    color: #333333
  }
  to {
    color: #0d6efd
  }
`

export const Container = styled.div`
  height: auto;
  min-height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
`

export const Content = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  align-items: center;
  justify-content: center;

  gap: 10px;
`

export const Title = styled.h1`
  font-size: 42px;
  font-weight: bold;

  span {
    animation: ${changeColor} 0.9s linear 2s infinite alternate;
  }
`

export const Article = styled.article`
  width: 40%;
  height: 150px;
  border-radius: 15px;

  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  cursor: pointer;

  &:hover {
    background: #e9e9e9;
    transform: translateY(-5px);
  }
`

export const ArtIcon = styled.div`
  width: 15%;
  height: 100%;
  padding: 10px;

  display: flex;
  justify-content: flex-start;
`

export const StyledIcon = styled.div`
  width: 40px;
  height: 40px;
  padding: 5px;
  margin-top: 10px;

  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 10px;

  display: flex;
  align-items: center;
  justify-content: center;
`

export const ArtInfo = styled.div`
  padding: 10px;
  height: 100%;

  display: flex;
  flex-direction: column;

  h1 {
    all: unset;
    font-size: 20px;
    font-weight: bold;
  }

  p {
    all: unset;
    font-size: 16px;
    font-weight: 400;
  }
`
export const ContentModalGif = styled.div`
  flex: 1;
  padding: 20px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    all: unset;
  }

  video {
    width: 600px;
    border: 3px solid black;
    border-radius: 3px;
    margin-top: 15px;
  }
`

export const Explication = styled.div`
  width: 75%;
  margin: 0 auto;

  p {
    font-size: 18px;
  }
`
